import type { PlpRoot } from '@core/Entities/Search/PlpRoot.entity';

import { ALWAYS_INDEXABLE_KEYS, MAX_NON_MMV_SLUG_PARAMS } from '../../Constants/Plp';
import type { Filter } from '../../Entities/Search/SearchFilters/Filter.entity';
import { getFilterFromArray } from '../SearchFilters/GetFilterFromArray';

export const hasSpaceInPath = (
  filtersData: { addition: Filter; pathList: Filter[]; allFilters: Filter[] },
  root: PlpRoot,
) => {
  const { addition, pathList, allFilters } = filtersData;

  if (ALWAYS_INDEXABLE_KEYS.includes(addition.id)) return true;

  const hasLocation = !!getFilterFromArray('area', allFilters);
  const freeSpots = hasLocation ? 0 : MAX_NON_MMV_SLUG_PARAMS[root];

  return (
    pathList.filter(pathFilter => !ALWAYS_INDEXABLE_KEYS.includes(pathFilter.id)).length < freeSpots
  );
};
